import axios from 'axios'
import logError from './logger'

export const getLegal = () => {
  return axios
    .get('/sources/static/index.json')
    .then(({ data }) => data.legal)
    .catch('ERROR GETLEGAL AXIOS CALL', logError)
}
